import React from 'react'
import styles from './TotalCountCard.module.scss';
import { ReactComponent as IconFilter } from '../../../../assets/icons/u_filters-v.svg';

interface Props {
    value?: number;
    title?: string;
    description?: string;
    selected?: boolean;
    onClick?: () => void;
}

const TotalCountCard = (props: Props) => {
    const isDisabled = props.value === 0;

    return (
        <div className={styles.contentContainer}>
            <div className={styles.buttonsContainer}>
                <div
                    className={`${styles.card} ${props.selected ? styles.selected : styles.unselected}`}
                    onClick={props.onClick}
                    role="button"
                    tabIndex={0}
                    onKeyDown={event => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            props.onClick?.();
                        }
                    }}
                >
                    <div className={styles.filterCards}>
                        <div className={`${styles.titleHead} ${isDisabled ? styles.disableContent : ''}`}>
                            <label className={`ci-type-heading-4 ${isDisabled ? styles.disableContent : ''}`}>{props.value}</label>
                            <label className={`ci-type-text-3 ${isDisabled ? styles.disableContent : ''}`}>{props.title}</label>
                        </div>
                        <label className={`ci-type-text-9 ${isDisabled ? styles.disableContent : ''}`}>{props.description}</label>
                    </div>
                    <div className={`${styles.iconFilter} ${isDisabled ? styles.disableContent : ''}`}>
                        <IconFilter />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TotalCountCard
